'use client';

import { useCurrentLocale } from '@locales/client';
import useSWR from 'swr';
import { fetcherWithToken } from '@/shared/api/fetcher';
import { isGameCatalogItem } from './types';

export type GameByRouteKey = readonly [
  endpoint: 'games/by-route',
  locale: string,
  providerId: string,
  gameCode: string,
];

export const getGameByRouteKey = (
  locale: string,
  providerId?: string | null,
  gameCode?: string | null
): GameByRouteKey | null => {
  const normalizedProviderId = providerId?.trim();
  const normalizedGameCode = gameCode?.trim();

  if (!normalizedProviderId || !normalizedGameCode) return null;

  return ['games/by-route', locale, normalizedProviderId, normalizedGameCode];
};

const fetchGameByRoute = async ([
  ,
  ,
  providerId,
  gameCode,
]: GameByRouteKey): Promise<unknown> => {
  const query = new URLSearchParams({ providerId, gameCode });
  return fetcherWithToken(`/games/by-route?${query.toString()}`);
};

export const useGameByRoute = (
  providerId?: string | null,
  gameCode?: string | null
) => {
  const locale = useCurrentLocale();
  const key = getGameByRouteKey(locale, providerId, gameCode);
  const { data, isLoading, error } = useSWR<
    unknown,
    unknown,
    GameByRouteKey | null
  >(key, fetchGameByRoute);

  return {
    game: isGameCatalogItem(data) ? data : null,
    isLoading: key ? isLoading : false,
    error,
  };
};
